import React from 'react'
import { useFormContext } from 'react-hook-form'
import useSessionStorage from '../../hooks/useSessionStorage'
import { initialFields } from '../../consts'

export default function NumVia({ title, label, required = true }) {
  const {
    register,
    setValue,
    getValues,
    formState: { errors },
  } = useFormContext()

  const [storageData, setStorageData] = useSessionStorage(
    'app_data',
    initialFields
  )

  const handleChange = () => {
    setStorageData(getValues())
  }

  return (
    <div className="form-field">
      {title && <span>{title}</span>}
      <div className="form-group">
        <label htmlFor="MCCPERSTAG.TOMADOR.NumVia">{label || 'Nº'}</label>
        <input
          id="MCCPERSTAG.TOMADOR.NumVia"
          className={`form-control${
            errors?.MCCPERSTAG?.TOMADOR?.NumVia ? ' hasError' : ''
          }`}
          type="text"
          {...register('MCCPERSTAG.TOMADOR.NumVia', {
            onChange: handleChange,
            required: required === true ? 'El número es obligatorio.' : false,
            pattern: {
              value: /^[0-9-]*$/i,
              message: 'Has introducido caracteres no permitidos.',
            },
            maxLength: {
              value: 4,
              message: 'El número es demasiado largo.',
            },
          })}
        />
      </div>

      {errors?.MCCPERSTAG?.TOMADOR?.NumVia && (
        <div className="error">
          <p>{errors.MCCPERSTAG.TOMADOR.NumVia.message}</p>
        </div>
      )}
    </div>
  )
}
